export default defineNuxtRouteMiddleware(() => {
    const { isOnboardingInProgress } = useOnboarding();
    const { openOnboardingModal } = useModals();

    if (isOnboardingInProgress.value && import.meta.client) {
        openOnboardingModal();
    }
});
